import { useState } from 'react'
import { useFieldError } from '~/components/FormContext'
import { Title } from '~/components/Title'
import { Selector } from '~/components/Selector'

export const Donation = () => {
  const [isConsentToDonate, setIsConsentToDonate] = useState()
  const organs = ['Heart', 'Liver', 'Kidneys', 'Pancreas', 'Bowel', 'Eyes', 'Tissue', 'Lung']
  const [selection, setSelection] = useState(() =>
    organs.reduce((result, organ) => {
      result[organ] = false
      return result
    }, {}),
  )

  const handleChange = ({ target: { id } }) => {
    const isConsentToDonate = id === 'yes'
    setIsConsentToDonate(isConsentToDonate)
    if (isConsentToDonate) {
      const clone = { ...selection }
      Object.keys(clone).forEach((organ) => {
        clone[organ] = true
      })
      setSelection(clone)
    }
  }

  const handleSelectionChange = (e) => {
    const {
      target: {
        checked,
        dataset: { name },
      },
    } = e
    const updatedSelection = { ...selection, [name]: checked }
    setSelection(updatedSelection)
  }

  const getChecked = (organ) => selection[organ] || false
  const donationError = useFieldError('isConsentToDonate')
  const transplantError = useFieldError('transplant')
  const radioClass = 'form-radio mx-2 h-6 w-6 text-primary-blue print:h-3 print:w-3'

  return (
    <>
      <Title content="Donation Decision" />
      <div>
        I consent to help save lives by becoming an organ and tissue donor after my death:
        <div className='flex flex-col gap-2'>
          <div>
            <input
              type="radio"
              id="yes"
              name="isConsentToDonate"
              onChange={handleChange}
              value="yes"
              className={radioClass}
            />
            <label htmlFor="yes">Yes</label>
          </div>
          <div>
            <input
              type="radio"
              id="no"
              name="isConsentToDonate"
              onChange={handleChange}
              value="no"
              className={radioClass}
            />
            <label htmlFor="no">No</label>
          </div>
        </div>
        {donationError && <p className="font-bold text-red-900">{donationError}</p>}
      </div>
      {isConsentToDonate && (
        <>
          <div className="w-full xl:w-1/2">
            <div className="my-2 grid grid-flow-col grid-rows-4 gap-4 print:grid-rows-2 print:gap-2">
              {organs.map((organ, i) => (
                <Selector
                  key={i}
                  name={organ}
                  onChange={handleSelectionChange}
                  checked={getChecked(organ)}
                />
              ))}
            </div>
          </div>
          {transplantError && <p className="font-bold text-red-900">{transplantError}</p>}
          <div className="block">
            <div className="mt-2">
              <label htmlFor={'resarch'} className="inline-flex items-center">
                <span className="mr-2">
                  After donation my organs and tissues may also be used for research
                </span>
                <input
                  type="checkbox"
                  id={'isConsentToResearch'}
                  name={'isConsentToResearch'}
                  className="checkbox form-checkbox"
                />
              </label>
            </div>
          </div>
        </>
      )}
    </>
  )
}
